import { getAdaptiveDecimalPlaces } from '../utils/number';

export const THOUSANDS_SEPARATOR_NBSP = '\u00A0';
export const DECIMAL_SEPARATOR_COMMA = ',';

export default {
  methods: {
    truncate(str, maxLen) {
      if (str && str.length > maxLen) {
        return str.substr(0, maxLen) + '...';
      }
      return str;
    },
    makeChartLabel(str, maxLen) {
      if (str.length > maxLen) {
        let text = str;
        let result = [];
        while (text.length > maxLen) {
          var idx = text.lastIndexOf(' ', maxLen);
          if (idx > -1) {
            result.push(text.substr(0, idx));
            text = text.substr(idx);
          }
        }
        result.push(text);
        return result;
      }
      return str;
    },
    /**
     * метод форматирования числа
     * @param {*} value - значение
     * @param {*} decimalPlaces - кол-во знаков после запятой
     * @param {*} groupSep - знак для разделения разрядов числа (1 000)
     * @param {*} decimalSep - разделительный знак числа
     * @param {*} removeTrailingZeros - флаг для удаления нуля на границе числа
     * @returns
     */
    formatNumber(value, decimalPlaces = 2, groupSep = ' ', decimalSep = ',', removeTrailingZeros = false) {
      if (typeof value === 'undefined' || value === null) return '';
      const parts = removeTrailingZeros
        ? String(parseFloat(value.toFixed(decimalPlaces))).split('.')
        : value.toFixed(decimalPlaces).split('.');
      const numberPart = parts[0];
      const decimalPart = parts[1];
      const thousands = /\B(?=(\d{3})+(?!\d))/g;
      return numberPart.replace(thousands, groupSep) + (decimalPart ? decimalSep + decimalPart : '');
    },

    /**
     * Возвращает строку с заглавной буквы
     *
     * @param {string} str
     * @returns {string} Строка с заглавной буквы
     */
    capitalize(value) {
      const str = String(value);
      return str[0].toUpperCase() + str.slice(1);
    },
    /**
     * Метод форматирования числа с адаптивным количеством знаков после запятой.
     * Количество знаков определяется через getAdaptiveDecimalPlaces(value).
     *
     * @param {*} value - значение
     * @param {*} groupSep - знак для разделения разрядов числа (1 000)
     * @param {*} decimalSep - разделительный знак числа
     * @param {*} removeTrailingZeros - флаг для удаления нуля на границе числа
     * @returns
     */
    formatAdaptiveNumber(
      value,
      groupSep = THOUSANDS_SEPARATOR_NBSP,
      decimalSep = DECIMAL_SEPARATOR_COMMA,
      removeTrailingZeros = false,
    ) {
      return this.formatNumber(value, getAdaptiveDecimalPlaces(value), groupSep, decimalSep, removeTrailingZeros);
    },
  },
};
